import { HelperInitializer } from '../Helper/HelperInitializer';
export class HistoryInitializer {
	private INITIAL_ENTRIES = 5;

	private loadMoreButton: HTMLButtonElement | null = document.querySelector('#history-load-more');

	private years: NodeListOf<HTMLDivElement> = document.querySelectorAll('.history-module-container .year-container');

	public init = () => {
		if (!window.matchMedia('(max-width: 767px)').matches) {
			this.years.forEach((year, idx) => {
				if (idx === this.INITIAL_ENTRIES - 1) {
					year.classList.add('fade-out');

					const observer = HelperInitializer.createObserver((element: Element) => {
						this.years.forEach((year) => year.classList.remove('hidden', 'fade-out'));
					});
					observer.observe(year as Element);
				}

				if (idx >= this.INITIAL_ENTRIES) year.classList.add('hide');
			});
		} else {
			// Load more button only for mobile
			if (this.loadMoreButton == null) return;

			if (this.years.length > this.INITIAL_ENTRIES) this.loadMoreButton.classList.remove('hidden');

			this.years.forEach((year, idx) => {
				if (idx === this.INITIAL_ENTRIES - 1) year.classList.add('fade-out');

				if (idx >= this.INITIAL_ENTRIES) year.classList.add('hidden');
			});

			this.loadMoreButton.addEventListener('click', (e) => {
				e.preventDefault();

				this.years.forEach((year) => year.classList.remove('hidden', 'fade-out'));

				this.loadMoreButton!.classList.add('hidden');
			});
		}
	};
}
